/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
const TreeNode = require('../TreeNode');
const BattleCalc = require('../../BattleCalc');
const UseAbility = require('../UseAbility');
const Q_any_enemies = require('./Q_any_enemies');
const AICalc = require('../AICalc');

const Q_taunt_or_chain_pull = function (actor, battleState, moveTowards) {
  const node = new TreeNode(actor, battleState);

  // branch indexes
  node.TAUNT = 0;
  node.CHAIN_PULL = 1;
  node.BUFFS = 2;

  node.taunt = BattleCalc.getEquippedAbility(actor, 'taunt');
  node.chainPull = BattleCalc.getEquippedAbility(actor, 'chain_pull');

  if (node.taunt) {
    node.branches[node.TAUNT] = new UseAbility(actor, 'taunt');
  }

  if (node.chainPull) {
    node.branches[node.CHAIN_PULL] = new UseAbility(actor, 'chain_pull');
  }

  node.branches[node.BUFFS] = new Q_any_enemies(
    actor,
    battleState,
    moveTowards
  );

  const originalDispose = node.dispose;
  node.dispose = function() {
    node.taunt = null;
    node.chainPull = null;
    originalDispose.call(node);
  };

  node.query = function () {
    const bestTarget = AICalc.getBestMissileTarget(actor, battleState);

    if (!bestTarget || BattleCalc.getCondition(bestTarget, 'scared')) {
      return this.branches[this.BUFFS].query();
    }

    if (
      this.taunt &&
      !BattleCalc.getCondition(bestTarget, 'enraged') &&
      !BattleCalc.getCondition(bestTarget, 'stunned') &&
      !BattleCalc.getCondition(bestTarget, 'unshakeable')
    ) {
      return this.branches[this.TAUNT].query(bestTarget);
    } else if (this.chainPull) {
      return this.branches[this.CHAIN_PULL].query(bestTarget);
    } else {
      return this.branches[this.BUFFS].query();
    }
  };

  return node;
};
module.exports = Q_taunt_or_chain_pull;
